<template>
    <div id="add-item-to-basket-overlay">
        <div class="modal fade">
            <div class="modal-dialog modal-xl overflow-x-hidden modal-dialog-scrollable" role="document">
                <div class="modal-content overflow-x-hidden" v-if="basketItem">

                    <!-- MODAL HEADER -->
                    <div :class="['modal-header d-flex justify-content-start', { 'no-body-content': isModalBodyEmpty }]">
                        <img :src="basketItem.variation.data.images.all[0].urlPreview" :alt="basketItem.variation.data.images.all[0].names.alternate" class="basketItemImage img-fluid float-left mr-2">
                        <div class="d-flex flex-column">
                            <h3>{{ $translate("GonserDT::Template.basketOverlayHeadline") }}</h3>
                            <p>{{ $translate("GonserDT::Template.basketOverlayText") }}</p>
                        </div>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </button>
                    </div>
                    <!-- ./MODAL HEADER -->

                    <!-- MODAL BODY -->
                    <div :class="['modal-body p-0 overflow-x-hidden position-relative', { 'no-body-content': isModalBodyEmpty }]">
                        <div>
                            <gonser-box :isBasketOverlay="true"></gonser-box>
                        </div>
                        <slot name="additionalContent"></slot>
                    </div>
                    <!-- ./MODAL BODY -->

                    <!-- MODAL FOOTER -->
                     <div :class="['modal-footer', { 'no-body-content': isModalBodyEmpty }]">
                        <div ref="btnWrapper" class="btn-wrapper d-flex justify-content-around py-4 px-3">
                            <button type="button" class="btn mt-md-0 d-flex align-items-center w-100 flex-grow-1 justify-content-center mr-2" data-dismiss="modal" aria-label="Close">
                                <i class="fa fa-times mr-2" aria-hidden="true"></i>
                                <span>{{ $translate("GonserDT::Template.basketContinueShopping") }}</span>
                            </button>

                            <a v-waiting-animation-infinite :href="urls.basket" rel="nofollow" class="d-none d-md-flex btn btn-secondary btn-block mt-md-0 mx-md-1 flex-grow-1 justify-content-center mx-2">
                                <i class="fa fa-chevron-right mr-2" aria-hidden="true"></i>
                                {{ $translate("Ceres::Template.basket") }}
                            </a>

                            <a v-waiting-animation-infinite :href="urls.checkout" rel="nofollow" class="btn btn-success mt-md-0 d-flex align-items-center w-100 flex-grow-1 justify-content-center ml-2">
                                <i class="fa fa-chevron-right mr-2" aria-hidden="true"></i>
                                <span>{{ $translate("Ceres::Template.basketCheckout") }}</span>
                            </a>
                        </div>
                    </div>
                    <slot name="extendOverlayButtons"></slot>
                    <slot name="extendOverlayFooter"></slot>
                    <!-- ./MODAL FOOTER -->

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { isNullOrUndefined } from "../../helper/utils";
import { mapState } from "vuex";

const ModalService  = require("../../services/ModalService");
const ApiService    = require("../../services/ApiService");

export default {
    props: {
        defaultTimeToClose: {
            type: Number,
            default: 15
        }
    },

    data()
    {
        return {
            price: 0,
            basketItem: null,
            countAdditionalBasketItems: 0,
            isModalBodyEmpty: true
        };
    },

    mounted()
    {
        if (App.config.basket.addItemToBasketConfirm === "overlay")
        {
            ApiService.listen("AfterBasketItemUpdate", data =>
            {
                const updatedBasketItem = data.basketItems[0];

                if (!this.isBasketItemQuantityUpdate)
                {
                    const basketItem = this.basketItems.find(item => item.id === updatedBasketItem.id) || {};

                    this.showItem(basketItem);
                }
            });

            ApiService.listen("AfterBasketItemAdd", data =>
            {
                this.showItem(data.basketItems[0], data.basketItems.length - 1);
            });
        };
        this.$nextTick(() =>
        {
            this.checkModalBodyContent();
        });
    },

    computed:
    {
        ...mapState({
            basketItems: state => state.basket.items,
            isBasketItemQuantityUpdate: state => state.basket.isBasketItemQuantityUpdate
        }),

        isLastBasketEntrySet()
        {
            return !isNullOrUndefined(this.basketItem);
        },

        variation()
        {
            if (this.basketItem)
            {
                return this.basketItem.variation ? this.basketItem.variation.data : null;
            }

            return null;
        },

        itemName()
        {
            if (this.isLastBasketEntrySet)
            {
                return this.$options.filters.itemName(this.variation);
            }

            return "";
        },

        imageUrl()
        {
            if (this.isLastBasketEntrySet)
            {
                const images = this.$options.filters.itemImages(this.variation.images, "urlPreview");

                return this.$options.filters.itemImage(images);
            }

            return "";
        },

        imageAlternativeText()
        {
            if (this.isLastBasketEntrySet)
            {
                const images = this.$options.filters.itemImages(this.variation.images, "urlPreview");

                return this.$options.filters.itemImageAlternativeText(images);
            }

            return "";
        },

        urls()
        {
            return {
                basket: App.urls.basket,
                checkout: App.urls.checkout
            }
        },

        shownOrderProperties()
        {
            return this.basketItem.basketItemOrderParams.filter(property =>
            {
                return !!this.variation.properties.find(prop => prop.propertyId == property.propertyId);
            });
        }

    },

    watch: {
        basketItem() {
            this.$nextTick(() => {
                this.checkModalBodyContent();
            });
        },
        countAdditionalBasketItems() {
            this.$nextTick(() => {
                this.checkModalBodyContent();
            });
        }
    },

    methods:
    {
        showItem(basketItem, countAdditionalBasketItems)
        {
            this.basketItem = basketItem;
            this.countAdditionalBasketItems = countAdditionalBasketItems;
            this.price = basketItem.price;

            ModalService
                .findModal(document.getElementById("add-item-to-basket-overlay"))
                .show();
        },

        checkModalBodyContent() {
            const modalBody = this.$el.querySelector('.modal-body');
            if (!modalBody) {
                this.isModalBodyEmpty = true;
                return;
            }

            function isEmpty(element) {
                if (!element) return true;
                if (element.nodeType === Node.TEXT_NODE && element.textContent.trim() !== "") return false;
                if (element.nodeType === Node.ELEMENT_NODE) {
                    for (let child of element.childNodes) {
                        if (!isEmpty(child)) return false;
                    }
                }
                return true;
            }

            this.isModalBodyEmpty = isEmpty(modalBody);
        }
    }
}
</script>
